import React, { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { NewPlanYearSelector } from 'adminDashboard/benefitDetails/common/NewPlanYearSelector'
import BulkEmployeeUpload from 'csiDashboard/bulkEmployeeUpload'

import { ProductIds } from 'core/application/commons/config'
import { CompanyInfoDetails } from 'core/application/csiDashboard/csiSearch/getCompanyInfo'
import { BenefitDetails } from 'core/application/csiDashboard/csiSearch/getCompanyInfo'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import { Col, Row, Tabs } from 'common/components'

import BenefitClasses from '../common/benefitClasses'
import People from '../common/people'
import ProductDetails from '../common/productDetails'
import SubscriptionExpiredInfo from '../common/subscriptioExpiredInfo'
import ProgramDetails from './programDetails'

const getPlanYearSelector = (
  planPeriods: any[] | undefined,
  selected: string | undefined,
  setActivePlanPeriod: (planPeriod: string) => void,
): ReactNode => {
  return [
    <>
      {planPeriods ? (
        <NewPlanYearSelector planPeriods={planPeriods} selected={selected} setActivePlanPeriod={setActivePlanPeriod} />
      ) : null}
    </>,
  ]
}

type IchraQompanyDetailsProps = {
  companyInfoDetails: CompanyInfoDetails
}
const IchraCompanyDetails = (props: IchraQompanyDetailsProps) => {
  const { t: translate } = useTranslation()
  const [planPeriods, setPlanPeriods] = useState<BenefitDetails[] | undefined>(undefined)
  const [activePlanPeriod, setActivePlanPeriod] = useState<string | undefined>(undefined)

  useEffect(() => {
    const activeBenefits =
      props.companyInfoDetails.benefits.length > 1
        ? props.companyInfoDetails.benefits.filter(
            (x: BenefitDetails) =>
              x.benefitDesignStatus != BenefitDesignStatus.NotStarted && x.productTypeId == ProductIds.IchraId,
          )
        : props.companyInfoDetails.benefits
    const currentPlan = activeBenefits.filter((x: any) => x.active && x.productTypeId == ProductIds.IchraId)
    setActivePlanPeriod(currentPlan[0] ? currentPlan[0].id : activeBenefits[0]?.id)
    setPlanPeriods(activeBenefits.length > 0 ? activeBenefits : props.companyInfoDetails.benefits)
  }, [props.companyInfoDetails])

  const productInfo = props.companyInfoDetails.companyDetails.products.find((x: any) => x.id == ProductIds.IchraId)

  return (
    <>
      <SubscriptionExpiredInfo companyId={props.companyInfoDetails.companyDetails.id} productId={ProductIds.IchraId} />

      {productInfo && <ProductDetails product={productInfo} />}

      {props.companyInfoDetails && activePlanPeriod && (
        <Row>
          <Col md={24} className="mt-16">
            <Tabs
              panes={[
                {
                  key: 'reimbursements-due',
                  title: <h6>{`${translate('csi-dashboard.people.people')}`}</h6>,
                  content: (
                    <People
                      companyId={props.companyInfoDetails.companyDetails.id}
                      companyName={props.companyInfoDetails.companyDetails.name}
                      productId={ProductIds.IchraId}
                    />
                  ),
                },
                {
                  key: 'history',
                  title: <h6>{translate('csi-dashboard.program-details.title')}</h6>,
                  content: (
                    <ProgramDetails
                      companyId={props.companyInfoDetails.companyDetails.id}
                      planPeriodId={activePlanPeriod}
                      translate={translate}
                      productId={ProductIds.IchraId}
                    />
                  ),
                },
                {
                  key: 'classes',
                  title: <h6>Classes</h6>,
                  content: (
                    <BenefitClasses
                      translate={translate}
                      planPeriodId={activePlanPeriod}
                      productId={ProductIds.IchraId}
                    />
                  ),
                },
                {
                  key: 'bulk-upload',
                  title: <h6>Bulk Employee Upload</h6>,
                  content: (
                    <BulkEmployeeUpload
                      companyId={props.companyInfoDetails.companyDetails.id}
                      productId={ProductIds.IchraId}
                      planPeriodId={activePlanPeriod}
                    />
                  ),
                },
              ]}
              tabBarExtraContent={getPlanYearSelector(planPeriods, activePlanPeriod, setActivePlanPeriod)}
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default IchraCompanyDetails
